import { CheckIconItem } from './CheckIcon';
import { ItemFormFilling } from '../Filling/Types';
import { useContext, useEffect } from 'react';
import { NewWebFormContext } from '../../context/NewWebFormContext';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';


export default function CheckIconItemComp({ item }: { item: ItemFormFilling }) {
  const { changeValue } = useContext(NewWebFormContext);

  useEffect(() => {
  }, [changeValue])

  const checkValues = () => {
    switch (CheckIconItem(item)) {
      case 'ok':
        return (<TaskAltIcon color='success' />)
      case 'naoOk':
        return (<PriorityHighIcon color='warning' />)
      default: return (<></>)
    }
  }


  return (
    <>
      {checkValues()}
    </>
  )
}